import dayjs from "@/lib/day";
export default function calcAge(birthday) {
  var today = dayjs();
  var birthDate = dayjs(birthday);
  var baseAge = today.year() - birthDate.year();
  var thisBirthday = dayjs("".concat(today.year(), "-").concat(birthDate.month() + 1, "-").concat(birthDate.date()));
  var age = today.isBefore(thisBirthday) ? baseAge - 1 : baseAge;
  if (isNaN(age)) return 0;
  return age < 0 ? 0 : age;
}